import {
  type GlobalStateModel,
  useGlobalStateContextSelectors,
} from 'components/GlobalState/GlobalStateModel';
import {
  type LicenseFeatureAvailability,
  getLicenseFeatureAvailability,
} from 'utils/license/licenseFeatures';

export const useLicenseFeatureAvailability = (): LicenseFeatureAvailability => {
  const { license } = useGlobalStateContextSelectors({
    license: (state: GlobalStateModel) => state.license,
  });

  return getLicenseFeatureAvailability(license);
};
